import { transientStorageManager } from 'businesslayer/minutesSessionStore'
import { getLocalStorageItem } from 'businesslayer/minutesLocalStore'
import { getLocalizedLanguage } from 'common/util/langMap'
import { boardeffectURL, defaultHelpURL, getBoardsHelpURL } from 'common/util/urlMap'

export const getHelpURL = () => {
    const { platform } = transientStorageManager

    let userLang = getLocalStorageItem('userLanguage') || 'en'
    const localizedLang = getLocalizedLanguage(userLang)

    const boardsHelpURL = getBoardsHelpURL(localizedLang)

    const helpURLMap: Record<Platform, string | null> = {
        boardeffect: boardeffectURL,
        boards: boardsHelpURL,
        boardswebadmin: boardsHelpURL,
        boardswebdirector: boardsHelpURL,
        boardsios: null,
        mock: defaultHelpURL
    }

    return helpURLMap[platform || ''] || defaultHelpURL
}
